<template>
  <div class="studentInfo-switch-class">
    <el-dialog title="批量修改学生" :visible="dialogVisible" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" width="580px" center>
      <div>
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <el-form-item label="已选择学生:" label-width="100px">
            <!-- <el-input
              v-model="teacherInfo.teacherName"
              :disabled="true"
              style="width: 200px"
            ></el-input> -->
            <el-tag v-for="item in studentSelectList" :key="item.id" style="margin-right: 4px">{{ item.studentName
            }}</el-tag>
          </el-form-item>
          <el-form-item label="选择年级:" label-width="100px" prop="gradeId">
            <el-select v-model="formData.gradeId" placeholder="选择年级" @change="selectGrade" clearable>
              <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName"
                :value="item.gradeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择班级" label-width="100px" prop="classId">
            <el-select v-model="formData.classId" placeholder="选择班级" @change="selectClass" clearable>
              <el-option v-for="item in classSelectList" :key="item.classId" :label="item.className"
                :value="item.classId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择状态:" prop="status" label-width="100px">
            <el-select v-model="formData.status" placeholder="请选择">
              <el-option v-for="item in studentTypeList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  // props: {
  //   dialogVisible: {
  //     type: Boolean,
  //     require: true,
  //   },
  //   studentSelectList: {
  //     type: Array,
  //   },
  // },
  props: [
    "dialogVisible",
    "studentSelectList",
    "classProps",
    "classSelect",
    "classPlaceholder",
    "className",
    "studentTypeList",
    "gradeSelectList",
  ],
  inject: ["refresh"],
  data() {
    return {
      formData: {
        classNameVal: "",
        status: "",
        classId: "",
        gradeId: "",
        gradeName: "",
        className: "",
      },
      classSelectList: [],
      rules: {
        classId: [
          { required: false, message: "请选择班级", trigger: "change" },
        ],
        gradeId: [
          { required: false, message: "请选择年级", trigger: "change" },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  methods: {
    // 切换年级
    selectGrade(e) {
      // console.log(e);
      this.formData.gradeId = e;
      this.formData.classId = "";
      this.formData.className = "";
      this.formData.gradeName = this.gradeSelectList.find(item => item.gradeId == e).gradeName;
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.gradePlaceholder = "请选择年级";
        this.classSelectList = [];
      }
    },
    selectClass(e) {
      this.formData.classId = e;
      if (e != '') {
        this.formData.className = this.classSelectList.find(item => item.classId == e).className;
      } else {
        this.formData.className = '';
      };
    },
    dialogOpen() {
      // this.formData.classNameVal = this.className;
      this.formData = {
        classNameVal: "",
        status: '0',
        classId: "",
        gradeId: "",
        gradeName: "",
        className: "",
      };
    },
    dialogClose() {
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
      this.$emit("update:dialogVisible", false);
    },
    confrim() {
      // console.log(this.formData);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("studentSwitchClass", this.formData);
        } else {
          return false;
        }
      });

    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentInfo-switch-class.scss";
</style>
